import {useEffect, useState, useRef} from 'preact/hooks';
import {application} from '~/locals/qianfan/index';
import {useQfScreen} from '../comp/utils/hook';
import {CommonCard} from './AppBuilder';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'application';
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';
const Application = () => {
    const {list, title, title_m, desc, descLink} = application;
    const {screenWidth} = useQfScreen();
    useCptDuration(id, {
        name: `${applicationName}-${title}-停留时长`
    });

    return (
        <div className="application" id={id}>
            <div className="module-wrapper">
                <div className="bg"></div>
                <div className="module-container">
                    <h2 className={`title ${moduleTitleClassName}`}>{screenWidth > 599 ? title : title_m}</h2>
                    <p className={`module-desc no_rem_fs_16 ${moduleDescClassName}`}>
                        {desc}
                        <br className="wrap" />
                        {/* eslint-disable-next-line max-len */}
                        <a
                            href={descLink.link}
                            target="_blank"
                            className="module-desc-link no_rem_fs_16"
                            rel="noreferrer"
                            {...descLink.trackInfo}
                        >
                            <span>{descLink.text}</span>
                            <span className="qf-icon no_rem_qf-icon"></span>
                        </a>
                    </p>
                    <CommonCard data={{list, id}} />
                </div>
            </div>
        </div>
    );
};

export default Application;
